<template>
  <div class="second-container">
    <AdminLeft/>
    <div class="column-con">
      <AdminTop/>
      <div class="title">欢迎使用 中国科技创新协会 后台管理系统</div>
      <div class="cell-con">
        <img src="../../assets/images/1.png" alt="" class="img-s">
        <img src="../../assets/images/2.png" alt="" class="img-s">
        <img src="../../assets/images/3.png" alt="" class="img-s">
      </div>
    </div>
  </div>
</template>

<script>
import AdminLeft from "@/components/AdminLeft";
import AdminTop from "@/components/AdminTop";

export default {
  name: "AdminHome",
  components: {
    AdminLeft,
    AdminTop
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped>
.column-con {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
}
.cell-con {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.title {
  font-size: 50px;
  font-weight: bold;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 100px;
  margin-bottom: 200px;
}
.img-s {
  height: 300px;
  width: auto;
  margin: 0 100px;
}
</style>